<template>
  <div>
    <CustomDialog
      v-model="dialog"
      ref="customDialog"
      backgroundColor="transparent"
      hideHeader
      hideFooter
      fullscreen
    >
      <div
        v-if="dialog"
        class="d-flex flex-column fill-height fill-width align-center justify-center dialog-content"
      >
        <v-img :src="require('@/assets/home/sunburst.png')" height="100vh">
          <div
            class="d-flex flex-column fill-height fill-width align-center justify-center pa-2"
          >
            <v-btn
              :disabled="loading.scratch || started"
              icon
              absolute
              top
              right
              @click.stop.prevent="tryCloseDialog"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <div
              class="d-flex flex-wrap text-center text-h5 text-md-h4 font-weight-black font-italic bebas-neue"
            >
              COMECE A RASPAR
            </div>

            <div
              class="text-center text-body-1 text-md-h6 font-weight-black primary--text mb-3"
            >
              Encontre 3 iguais para ganhar!
            </div>

            <div
              class="d-flex justify-center mb-3"
              :class="{ 'ml-n6': _fakeScratchs }"
            >
              <div
                v-for="i in _fakeScratchs"
                :key="i"
                class="fake-scratch"
                :style="`transform: scale(${
                  0.95 - (_fakeScratchs - i) * 0.07
                }); margin-right: -${i === _fakeScratchs ? 240 : 242}px`"
              ></div>

              <div
                :class="{
                  'animate__animated animate__headShake': shouldShake,
                  'animate__animated animate__tada': shouldPulse,
                }"
              >
                <ScratchCard
                  v-if="scratchs[currentScratch]"
                  ref="scratchCard"
                  :scratch="scratchs[currentScratch]"
                  :loading="loading.scratch"
                  @started="handleStartedScratch()"
                  @revealed="revealPrize()"
                  @next="handleNext()"
                />
              </div>
            </div>

            <div
              v-if="scratchs.length > 1"
              class="text-center text-h6 font-weight-black white--text mb-3"
            >
              {{ scratchs.length }} Restantes
            </div>
          </div>
        </v-img>

        <v-overlay :value="showPrize" z-index="999" opacity="0.3">
          <div
            v-if="!!scratchs[this.currentScratch]?.result"
            class="d-flex flex-column justify-center align-center mb-6"
          >
            <v-img
              :src="
                scratchs[this.currentScratch].result.image ||
                (scratchs[this.currentScratch].result.type === 'event'
                  ? require(`@/assets/prizes/${
                      scratchs[this.currentScratch].result.event
                    }.png`)
                  : require(`@/assets/prizes/${
                      scratchs[this.currentScratch].result.type
                    }.png`))
              "
              class="pump mb-2"
              max-width="8rem"
              contain
            />

            <div class="glass-container text-center px-6 py-2 rounded-xl">
              <div class="text-body-1 font-weight-black white--text">
                {{ scratchs[this.currentScratch].result.name }}
              </div>

              <div class="font-weight-bold text-caption">
                Raridade:

                <span
                  :style="{ color: scratchs[this.currentScratch].result.color }"
                >
                  {{
                    handleRarityLabel(
                      scratchs[this.currentScratch].result.rarity
                    )
                  }}
                </span>
              </div>
            </div>
          </div>

          <div class="d-flex justify-center align-center">
            <v-btn class="btn" color="primary" rounded @click="handleNext()">
              <span>
                {{ scratchs.length > 1 ? "Continuar" : "Fechar" }}
              </span>

              <v-icon right small>
                {{ scratchs.length > 1 ? "fas fa-chevron-right" : "mdi-close" }}
              </v-icon>
            </v-btn>
          </div>
        </v-overlay>

        <Confetti v-if="confetti" />
      </div>
    </CustomDialog>

    <ScratchResult
      v-if="dialog"
      ref="scratchResult"
      :prizes="_prizes"
      @close="close()"
    />
  </div>
</template>

<script>
import { useItem } from "@/services/items";
import { handleRarityLabel } from "@/helpers";
import CustomDialog from "@/components/customDialog/CustomDialog";
import ScratchCard from "@/components/scratchCard/ScratchCard";
import Confetti from "@/components/confetti/Confetti.vue";
import ScratchResult from "./partials/scratchResult/ScratchResult.vue";
import "animate.css";

export default {
  name: "ScratchDialog",

  components: {
    CustomDialog,
    ScratchCard,
    Confetti,
    ScratchResult,
  },

  data() {
    return {
      loading: {
        scratch: false,
      },
      dialog: false,
      currentScratch: 0,
      scratchs: [],
      backupScratchs: [],
      showPrize: false,
      confetti: false,
      shouldShake: false,
      shouldPulse: false,
      prizeSound: null,
      lostSound: null,
      started: false,
    };
  },

  beforeMount() {
    this.prizeSound = new Audio(require("@/assets/sounds/tada.mp3"));
    this.lostSound = new Audio(require("@/assets/sounds/negative.mp3"));
  },

  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  watch: {
    shouldShake(val) {
      if (val) {
        setTimeout(() => (this.shouldShake = false), 500);
      }
    },

    shouldPulse(val) {
      if (val) {
        setTimeout(() => (this.shouldPulse = false), 1000);
      }
    },
  },

  computed: {
    _fakeScratchs() {
      if (this.scratchs.length <= 1) return 0;

      return this.scratchs.length > 4 ? 4 : this.scratchs.length - 1;
    },

    _prizes() {
      return this.backupScratchs.map((el) => el.result);
    },
  },

  methods: {
    open(data) {
      this.dialog = true;

      const qty = Number(data?.qty) || 0;
      this.scratchs = Array.from({ length: qty }, () => ({
        ...data.item,
        result: null,
      }));

      this.$nextTick(() => {
        this.initCanvas();
        this.resetScratch();
      });
    },

    async useItem() {
      try {
        this.loading.scratch = true;

        const scratchID = this.scratchs[this.currentScratch]._id;

        const payload = {
          target: "draws",
          targetID: scratchID,
          qty: 1,
        };

        const { data } = await useItem(scratchID, payload);

        this.scratchs[this.currentScratch].result = data;
        this.backupScratchs.push({ ...this.scratchs[this.currentScratch] });

        this.$root.$emit("load-session");
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading.scratch = false;
      }
    },

    handleStartedScratch() {
      if (this.scratchs[this.currentScratch].result) return;
      this.started = true;

      this.useItem();
    },

    initCanvas() {
      this.$refs.scratchCard.initCanvas();
    },

    resetScratch() {
      this.$refs.scratchCard.resetScratch();
    },

    revealPrize() {
      this.shouldPulse = true;

      const winner =
        this.scratchs[this.currentScratch].result.event !== "nothing";

      if (winner) this.triggerPrizeSound();
      else this.triggerLostSound();

      if (this.scratchs[this.currentScratch].result) {
        setTimeout(() => {
          this.started = false;
          this.showPrize = true;

          if (winner) this.confetti = true;
        }, 2500);
      }
    },

    handleNext() {
      this.$refs.scratchCard.resetScratch();

      if (this.scratchs.length) this.scratchs.splice(this.currentScratch, 1);

      this.showPrize = false;
      this.confetti = false;
      this.shouldShake = true;

      if (!this.scratchs.length) {
        this.$root.$emit("load-session");
        this.$refs.scratchResult.open();
        return;
      }

      this.currentScratch = 0;
    },

    triggerPrizeSound() {
      if (!this.prizeSound) return;

      const playPromise = this.prizeSound.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // ignore
        });
      }
    },

    triggerLostSound() {
      if (!this.lostSound) return;

      const playPromise = this.lostSound.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // ignore
        });
      }
    },

    handleBeforeUnload(event) {
      if (this.started) {
        event.preventDefault();
        event.returnValue =
          "Você já iniciou a raspadinha, finalize antes de sair!";
        return event.returnValue;
      }
    },

    tryCloseDialog() {
      if (this.started) {
        this.$alert(
          "Você já iniciou a raspadinha, finalize antes de sair!",
          "warning"
        );
        return;
      }

      this.close();
    },

    close() {
      this.loading.content = true;
      this.dialog = false;
      this.currentScratch = 0;
      this.scratchs = [];
      this.backupScratchs = [];
      this.showPrize = false;
      this.started = false;
    },

    handleRarityLabel,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
